import { KYCStatus, ThanksPageType } from "@funded-here-interface/common/src/constant/enum";
import { getThanksPageUrl } from "@funded-here-interface/common/src/Utils/navigation/constants";
import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { RootState } from "../../store";

/**
 * Keeps an approved supplier out of the onboarding steps. Login already routes
 * them to "Onboarding Completed", but the step routes themselves were open, so
 * a deep link reopened the editable forms (TC-041/042/043).
 *
 * Reads the KYC status login stored rather than refetching it, so this is a UI
 * guard only: the backend must still refuse saves from an approved supplier.
 */
const SupplierOnboardingGate: FC<{ children: ReactNode }> = ({ children }) => {
  const kycStatus = useSelector((state: RootState) => state.auth.kycStatus);

  if (kycStatus === KYCStatus.APPROVED) {
    return <Navigate to={getThanksPageUrl(ThanksPageType.ONBOARDING_COMPLETED_SUPPLIER)} replace />;
  }

  return <>{children}</>;
};

export default SupplierOnboardingGate;
